"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.opcionesGeneralesDefecto = void 0;
const opcionesGeneralesIntegracionFEPOS_1 = require("./opcionesGeneralesIntegracionFEPOS");
exports.opcionesGeneralesDefecto = {
    monedaDefecto: "",
    vistaPrecios: "sinIVA",
    tasaIVADefecto: "",
    moduloServicios: false,
    moduloProductos: false,
    centroCostos: false,
    unidades: false,
    moduloResguardos: false,
    moduloCaja: false,
    tiposCodigo: [],
    codigoImpresion: [],
    codigosLineaManual: false,
    modificarDecimales: false,
    cantidadDecimalesDefecto: 2,
    topeCuentaCorriente: false,
    domicilioEntrega: false,
    moduloRemitos: false,
    moduloImportador: false,
    moduloExportador: false,
    moduloRemitosSinStock: false,
    medioCobroDefecto: "efectivo",
    medioPagoDefecto: "efectivoPago",
    integracionFEPOS: opcionesGeneralesIntegracionFEPOS_1.opcionesGeneralesIntegracionFEPOSDefecto,
    integracionPOSHandy: {
        SystemId: "",
        habilitado: false,
        pos: []
    },
    integracionPOSOCA: {
        SystemId: "",
        habilitado: false,
        pos: []
    },
    integracionPOSFiserv: {
        SystemId: "",
        habilitado: false,
        pos: []
    },
    integracionPOSGetnet: {
        EmpHASH: "",
        EmpCod: "",
        habilitado: false,
        pos: []
    },
    integracionAbitab: false,
    codigoAbitab: "",
    imprimirTalonAbitab: false,
    integracionRedPagos: false,
    codigoRedPagos: "",
    imprimirTalonRedPagos: false,
    imprimirTicketCambio: false,
    cantDiasTicketCambio: 30
};
